import { render } from "./LocaleSelector.vue?vue&type=template&id=661f0b48&ts=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__